var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolEyedroperrMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86328 29.5234C5.86328 16.2686 16.6084 5.52344 29.8633 5.52344H77.8633C91.1181 5.52344 101.863 16.2686 101.863 29.5234V77.5234C101.863 90.7783 91.1181 101.523 77.8633 101.523H29.8633C16.6084 101.523 5.86328 90.7783 5.86328 77.5234V29.5234Z",
    fill: "url(#paint0_linear_219_4777)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4921 49.6088L50.3771 59.7237C49.567 60.5339 48.5022 60.7884 47.6921 59.9321C46.8588 59.0063 47.044 58.1499 47.9467 57.2239L57.9923 47.0627L56.0018 45.0952L37.2993 63.7976C30.1471 70.9499 33.5959 69.8388 29.7073 75.3246L31.7905 77.5234C37.091 73.6579 36.3735 77.454 43.6415 70.2092L62.4132 51.5531L60.4921 49.6088ZM66.0009 53.7982L66.6489 53.0808C67.7833 51.9003 67.8528 50.5115 66.6259 49.3079L65.9315 48.6366C69.4728 45.4656 73.4078 45.0258 75.8382 42.5491C79.2871 39.0772 78.1759 34.2164 75.7455 31.786C73.3383 29.3325 68.524 28.2909 64.9825 31.6934C62.4826 34.1007 62.0659 38.0587 58.8951 41.6001L58.2236 40.9057C57.0432 39.7021 55.6313 39.7484 54.451 40.8826L53.7565 41.5307C52.3214 42.8963 52.5991 44.0999 53.8027 45.3267L62.2048 53.7288C63.4316 54.9556 64.6584 55.2102 66.0009 53.7982Z",
    fill: "url(#paint1_linear_219_4777)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4777",
    x: 0.863281,
    y: 0.523438,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_219_4777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4777",
    x1: 53.8633,
    y1: 5.52344,
    x2: 53.8633,
    y2: 101.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4777",
    x1: 53.863,
    y1: 29.5234,
    x2: 53.863,
    y2: 77.5234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolEyedroperrMedium);
export default __webpack_public_path__ + "static/media/symbol-eyedroperr-medium.b60478094b6c244364a219ec2eaf0568.svg";
export { ForwardRef as ReactComponent };